import { MobileSideNav } from '@/src/components/root/GlobalSideNav/MobileSideNav/MobileSideNav';
import { useIsMobile } from '@/src/hooks/useIsMobile';
import { RoutePath } from '@/src/RoutePath';
import { documentationRoute, faqRoute, userGuideRoute } from '@/src/routes';
import {
  campaignSideNavRegex,
  challengeSideNavRegex,
  eventSideNavRegex,
  jamChallengeTaskRegex,
  jamChallengesRegex,
  userGuideRegex,
} from '@/src/utils/myjam.utils';
import { useLocation } from 'react-router-dom';
import { MyJamSidebar } from '../../event-templates-catalog/molecules/MyJamSidebar/MyJamSidebar';
import FAQSidebar from '../../faq/molecules/FAQSidebar/FAQSidebar';
import JamProfileSideNav from './JamProfileSideNav';
import { SideNav } from './SideNav';
import { SideNavigation } from '@amzn/awsui-components-react';
import { useSideNav } from '@/src/hooks/store/useSideNav';
import { config } from '@/src/config/app-config';

const GlobalSideNav = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  const { pathname } = location;
  const { userGuideToc } = useSideNav();

  // switch (activeNavMenu) {
  //   case NavMenu.Mobile:
  //     return <MobileSideNav />;
  //   case NavMenu.CatalogFilter:
  //     return <CatalogFilter />;
  //   default:
  //     return null;
  // }

  if (config.ff.enableS3HostedUserGuide && userGuideRegex.test(pathname)) {
    if (userGuideToc.length > 0) {
      return <SideNavigation items={userGuideToc} />;
    }
    return null;
  }

  if (jamChallengesRegex.test(pathname) || jamChallengeTaskRegex.test(pathname)) {
    return <MyJamSidebar />;
  }

  const faqPages = [faqRoute.path, documentationRoute.path, userGuideRoute.path];

  if (faqPages.find((path) => pathname.includes(path))) {
    return <FAQSidebar />;
  }

  const profilePaths = [RoutePath.JAM_PROFILE, RoutePath.JAM_PROFILE_DETAILS];

  if (profilePaths.includes(pathname as RoutePath)) {
    return <JamProfileSideNav />;
  }

  if (
    [
      RoutePath.EVENTS,
      RoutePath.CAMPAIGNS,
      RoutePath.ADMIN,
      RoutePath.SETTINGS,
      RoutePath.LABS,
      RoutePath.REPORTS,
    ].includes(pathname as RoutePath) ||
    eventSideNavRegex.test(pathname) ||
    campaignSideNavRegex.test(pathname) ||
    challengeSideNavRegex.test(pathname)
  ) {
    return <SideNav />;
  }

  if (isMobile) {
    return <MobileSideNav />;
  }

  return null;
};

export default GlobalSideNav;
